const Layout = () => import("@/layout/index.vue");

export default [
  {
    path: "/login",
    name: "Login",
    component: () => import("@/views/login/index.vue"),
    meta: {
      title: "登录",
      showLink: false,
      rank: 998
    }
  },
  {
    path: "/redirect",
    component: Layout,
    meta: {
      title: "加载中...",
      showLink: false,
      rank: 999
    },
    children: [
      {
        path: "/redirect/:path(.*)",
        name: "Redirect",
        component: () => import("@/layout/redirect.vue")
      }
    ]
  },
  {
    path: "/issue",
    name: "Issue",
    component: () => import("@/views/feedback/issue.vue"),
    meta: {
      title: "用户反馈收集",
      showLink: false,
      rank: 997
    }
  },
  {
    path: "/apply",
    name: "Apply",
    component: () => import("@/views/license/apply.vue"),
    meta: {
      title: "license申请",
      showLink: false,
      rank: 996
    }
  }
] satisfies Array<RouteConfigsTable>;
